import React from 'react'
import Logo from '../Signin/Logo_svg.svg';
import BackIcon from '../../pages/Register/Back.svg';
import './ForgotPassword.scss';
import {Link} from 'react-router-dom';

export default function ForgotPassword() {
    return (
        <div className="login-container-bg">
            <div className="overlay"></div>
            <div className="login-form">
                <div className="logo-container">
                    <Link to='/'><img src={Logo} alt="Logo"/></Link>
                    <p className="logo-title">GameMeet</p>
                </div>
                <div className="forgotpassword-form-container">
                    <div className="creat-form-container">
                            <Link to="./signin"><img src={BackIcon}/></Link>
                            <p className="creat-form-title">
                                Forgot Password
                            </p>
                    </div>
                    <div className="create-information-button">
                            <p>Email</p>
                            <input className="signin-button"></input>
                            <p className="error-message-forgot-password">The email field must be a valid email.</p>
                    </div>
                    <div className="reset-password-button">
                           <button className="login-button">Reset Password</button>
                    </div>
                    <p className="forgotpassword-extra-information">Type your email and we will send you a link in order to reset your password</p>
                    <p className="forgotpassword-scucess-information">A link has been sent to your email and please log in your temporary password</p>
                </div>
            </div>
        </div>
    )
}
